import styles from "./index.module.css";
import CarStats from "./CarStats";
import ImgOne from '../../../assets/images/about-us/vehicles-available.svg';
import ImgTwo from '../../../assets/images/about-us/happy-customers.svg';
import ImgThree from '../../../assets/images/about-us/24h-sup.svg';
import ImgFour from '../../../assets/images/about-us/car-models.svg';
import { useEffect } from "react";

const details = [
  {
    title: "About Us",
    imageUrl: "/about-us/about-us.jpg",
    organization: "Car Xchanger",
  },
];

const carStats = [
  {
    amount: "500+",
    imageUrl: ImgOne,
    description: "Vehicles Available",
  },
  {
    amount: "400+",
    imageUrl: ImgTwo,
    description: "Happy Customers",
  },
  {
    amount: "24+",
    imageUrl: ImgThree,
    description: "24/7 Support",
  },
  {
    amount: "125+",
    imageUrl: ImgFour,
    description: "Car Model & Make",
  },
];

const AboutUs = () => {
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <>
      <div className="main-container">
        <div className="container-content wrapped-content">
          <div className={styles.middleWrapper}>
            <div className={styles.middleTitle}>Why Do You Choose</div>
            <div className={styles.middleSubTitle}>Meegalla Holdings (Pvt) Ltd</div>
            <div className={styles.middleText}>
             It is our ultimate target to maintain our good name in the market and to serve our clients with utmost integrity, preserving their trust.
              <br />
              <br />
              You can always keep your trust on us for the superior quality and condition when it comes to our cars, and please go through our listings to find your dream car.
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bottomDetailsContainer}>
        <div className={styles.bottomSectionContainer}>
          {carStats.map((stat, i) => (
            <div key={i} className={styles.statDetails}>
              <CarStats
                amount={stat.amount}
                imageUrl={stat.imageUrl}
                description={stat.description}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AboutUs;